export const OPERATORS_MIXER = 'OPERATORS_MIXER';
export const LFO = 'LFO';
export const ENVELOPE = 'ENVELOPE';
export const FM_PARAMETERS = 'FM_PARAMETERS';
export const PLANAR_SNAPSHOTS = 'PLANAR_SHAPSHOTS';
export const JAKI_PARAMS = 'JAKI_PARAMS';
export const JAKI_FIGURES = 'JAKI_FIGURES';

export const TYPE_TO_COMPONENT = {
    JAKI_PARAMS: "jakiParamsComponent",
    PLANAR_SNAPSHOTS  : "snapshotComponent",
    JAKI_FIGURES : "figuresComponent"
};
